// Generated by Claude Code
import { ProcedureDetailPanel } from '#components/domain/operations/work-orders/procedures/procedure-detail-panel.tsx'
import { ProcedureEditDrawer } from '#components/domain/operations/work-orders/procedures/procedure-edit/index.tsx'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { readAnyGroups } from '#core/entities/auth/roles/permission-gate-helpers.ts'
import type Procedure from '#core/entities/operations/work-orders/Procedure.ts'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_app/$companyId/procedures/$procedureId')({
  component: RouteComponent,
  staticData: {
    title: 'Procedure Detail',
  },
})

function RouteComponent() {
  return (
    <PermissionGuard permissions={readAnyGroups(PermissionService.PROCEDURES)} redirectOnNotAuthorized>
      <ProcedureDetailPageContent />
    </PermissionGuard>
  )
}

function ProcedureDetailPageContent() {
  const { companyId, procedureId } = Route.useParams()
  const navigate = useNavigate()
  const { t } = useTranslation('procedures')

  const [editProcedure, setEditProcedure] = useState<Procedure | null>(null)
  // The panel has no reloadKey; bump this key to remount (and refetch) after an edit.
  const [reloadKey, setReloadKey] = useState(0)

  function handleBack() {
    void navigate({ to: '/$companyId/procedures', params: { companyId } })
  }

  return (
    <div className="container-fluid d-flex flex-column h-100 py-3">
      <div className="row justify-content-center flex-grow-1">
        <div className="col-12 col-lg-10 col-xl-8 d-flex flex-column">
          <div className="mb-2">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
              onClick={handleBack}
            >
              <ArrowLeft size={14} />
              {t('shared.actions.backToList')}
            </button>
          </div>
          <div className="flex-grow-1 overflow-hidden card rounded-3 p-0">
            <ProcedureDetailPanel
              key={reloadKey}
              procedureId={procedureId}
              onClose={handleBack}
              onEdit={(procedure) => setEditProcedure(procedure)}
            />
          </div>
        </div>
      </div>

      <ProcedureEditDrawer
        isOpen={editProcedure !== null}
        procedure={editProcedure ?? undefined}
        onClose={() => setEditProcedure(null)}
        onUpdated={() => { setEditProcedure(null); setReloadKey((k) => k + 1) }}
      />
    </div>
  )
}
